import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel, {
  ValueChangedEvent,
} from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnGetTableById } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { fnSave } from "@shared/api/restApi";
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnResizeBar from "@shared/components/SnResizeBar";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SN_QMS_REQ_REG_002_POP_01 from "@menu/QMS/SN_QMS_REQ_REG_002/SN_QMS_REQ_REG_002_POP_01";
import SN_QMS_REQ_REG_002_POP_02 from "@menu/QMS/SN_QMS_REQ_REG_002/SN_QMS_REQ_REG_002_POP_02";
import { RowNode } from "ag-grid-community";
import { useNavigate } from "react-router-dom";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_QMS_REQ_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const { menuItems } = useMenuStore();
  const [activeTab, setActiveTab] = useState("1");
  const searchRef = useRef<any>(null);
  const selectedTabPage = useRef<string>("1");
  const formControlDataRef = useRef<any[]>([]);
  const [selectedDocu, setSelectedDocu] = useState<string>(""); // file 관련
  const [focusedIndex, setFocusedIndex] = useState();
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
    grid4: React.createRef(),
  });
  const focusKeyRef = useRef<{
    no_lot?: string;
  } | null>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
  });
  const [btnText, setBtnText] = useState({
    report: "성적서작성",
    send: "발송",
  });
  // sys_config QMS0004 = "Y" 이면 발송 버튼을 숨기고 성적서작성 시 발송까지 자동 처리
  const [autoSend, setAutoSend] = useState(false);
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          grid4: rtn.grid.grid4,
        });

        const config = await fnGetTableById({
          id: "config",
          params: { cd_firm: userInfo.cd_firm, cd_ctrl: "QMS0004" },
        });
        if (Array.isArray(config) && config.length > 0) {
          setAutoSend(config[0].dc_ctrl === "Y");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchForm();
  }, []);

  // 검사항목(QMS_LOT_CERTH)의 합부판정이 전부 "Y"이면 의뢰정보(QMS_LOTH)의
  // 최종 합부판정도 "Y"로 맞춘다. (하나라도 "Y"가 아니면 "N")
  // 헤더가 "R"(세목판정)인 건은 판정을 유지한다.
  const getConfirmByLot = (certRows: any[]) => {
    const confirmByLot = new Map<string, boolean>();
    (certRows || []).forEach((row: any) => {
      const noLot = row?.no_lot;
      if (noLot === undefined || noLot === null) return;
      const isPass = row.yn_confirm === "Y";
      const prev = confirmByLot.get(noLot);
      confirmByLot.set(noLot, prev === undefined ? isPass : prev && isPass);
    });
    return confirmByLot;
  };

  // 조회 시점에 검사항목은 전부 합인데 의뢰정보가 합이 아닌 건을 맞춰서 저장한다.
  // (측정치입력/세목판정 팝업처럼 검사항목만 별도로 저장되는 경로 보정)
  const syncLothConfirm = async (lothRows: any[], certRows: any[]) => {
    const confirmByLot = getConfirmByLot(certRows);
    const updated: any[] = [];

    const nextRows = (lothRows || []).map((row: any) => {
      const allPass = confirmByLot.get(row?.no_lot);
      // 검사항목이 없거나 세목판정 건은 건드리지 않는다.
      if (allPass === undefined || row?.yn_confirm === "R") return row;

      const ynConfirm = allPass ? "Y" : "N";
      if (row.yn_confirm === ynConfirm) return row;

      const nextRow = { ...row, yn_confirm: ynConfirm };
      updated.push({
        cd_firm: nextRow.cd_firm,
        no_lot: nextRow.no_lot,
        yn_confirm: ynConfirm,
      });
      return nextRow;
    });

    if (updated.length > 0) {
      try {
        await fnSave("SN_QMS_REQ_REG_002_SAVE_01", {
          loth: {
            insert: [],
            update: updated,
            delete: [],
            modifiedRowcount: updated.length,
          },
        });
      } catch (error) {}
    }

    return nextRows;
  };

  // 그리드에서 검사항목 합부판정이 바뀌면 해당 LOT의 의뢰정보 합부판정을 맞춘다.
  const syncHeaderConfirmByLot = (noLot: string) => {
    if (noLot === undefined || noLot === null) return;

    const grid1 = gridRefs.current["grid1"].current;
    const grid2 = gridRefs.current["grid2"].current;
    if (!grid1 || !grid2) return;

    let hasRow = false;
    let allConfirmed = true;

    grid2.forEachNode?.((node: any) => {
      const data = node?.data;
      if (!data || node.rowPinned) return;
      if (data.no_lot !== noLot) return;

      hasRow = true;
      if (data.yn_confirm !== "Y") allConfirmed = false;
    });

    if (!hasRow) return;

    const ynConfirm = allConfirmed ? "Y" : "N";

    grid1.forEachNode?.((node: any) => {
      const data = node?.data;
      if (!data || node.rowPinned) return;
      if (data.no_lot !== noLot) return;
      if (data.yn_confirm === "R") return;
      if (data.yn_confirm === ynConfirm) return;

      grid1.setValueImmediately(node, "yn_confirm", ynConfirm);
    });
  };

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_qms_req_reg_002_01",
        params: searchRef.current.getFormdata(),
      };
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      gridRefs.current["grid4"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      const grid2Data = (data[1] || []).map((row: any) => ({
        ...row,
        cd_emp_cert:
          row.cd_emp_cert === null || row.cd_emp_cert === ""
            ? userInfo.cd_emp
            : row.cd_emp_cert,
        cd_dept_cert:
          row.cd_dept_cert === null || row.cd_dept_cert === ""
            ? userInfo.cd_dept
            : row.cd_dept_cert,
        nm_emp:
          row.nm_emp === null || row.nm_emp === ""
            ? userInfo.nm_emp
            : row.nm_emp,
        nm_dept:
          row.nm_dept === null || row.nm_dept === ""
            ? userInfo.nm_dept
            : row.nm_dept,
      }));
      const grid1Data = await syncLothConfirm(data[0] || [], grid2Data);
      setDataSources({
        grid1: grid1Data,
        grid2: grid2Data,
        grid3: data[2] || [],
        grid4: data[3] || [],
      });
    } catch (error: any) {}
  };
  const onSave = async () => {
    let lothChanges;
    let lotcerthChanges;
    let reqChanges;
    let lotbChanges;

    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();
      gridRefs.current["grid3"].current.stopEditing();
      gridRefs.current["grid4"].current.stopEditing();
      lothChanges = gridRefs.current["grid1"].current.getChange();
      lotcerthChanges = gridRefs.current["grid2"].current.getChange();
      reqChanges = gridRefs.current["grid3"].current.getChange();
      lotbChanges = gridRefs.current["grid4"].current.getChange();
      const saveData = {
        loth: lothChanges,
        lot_certh: lotcerthChanges,
        req: reqChanges,
        lotb: lotbChanges,
      };
      const ok = await fnSave("SN_QMS_REQ_REG_002_SAVE_01", saveData);
      if (!ok) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
        gridRefs.current["grid3"].current.resetUpdate(true);
        gridRefs.current["grid4"].current.resetUpdate(true);
        return false;
      }
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      gridRefs.current["grid4"].current.resetUpdate();
      const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedRow) {
        focusKeyRef.current = {
          no_lot: focusedRow.data.no_lot,
        };
      }
      await onSearch();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid3"].current.resetUpdate(true);
      gridRefs.current["grid4"].current.resetUpdate(true);
      return false;
    }
  };
  const onValueChaged = async (event: ValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;

    if (colId === "st_qc") {
      // 발송
      if (rowData.st_qc === "C") {
        setBtnText({
          report: "성적서작성",
          send: "발송취소",
        });
      }
      // LOT 생성
      else if (rowData.st_qc === "F") {
        setBtnText({
          report: "성적서작성",
          send: "발송",
        });
      }
      // 성적서 작성
      else {
        setBtnText({
          report: "성적서취소",
          send: "발송",
        });
      }
      onSearch();
    }
  };
  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "qt_pass") {
      rowNode.setDataValue(
        "qt_fail",
        rowData.qt_sample - rowData.qt_pass,
        "noEvent"
      );
      if (rowData.yn_insp === "Y") {
        if (rowData.yn_sample === "Y") {
          if (rowData.qt_fail <= rowData.qt_ac) {
            rowNode.setDataValue("yn_confirm", "Y");
          } else {
            rowNode.setDataValue("yn_confirm", "N");
          }
        } else {
          if (rowData.qt_pass > 0) {
            rowNode.setDataValue("yn_confirm", "Y");
          } else {
            rowNode.setDataValue("yn_confirm", "N");
          }
        }
      } else {
        if (rowData.yn_sample === "N") {
          if (rowData.qt_sample <= rowData.qt_pass)
            rowNode.setDataValue("yn_confirm", "Y");
          else rowNode.setDataValue("yn_confirm", "N");
        }
      }
    } else if (colId === "qt_fail") {
      rowNode.setDataValue(
        "qt_pass",
        rowData.qt_sample - rowData.qt_fail,
        "noEvent"
      );
      if (rowData.yn_sample === "Y") {
        if (rowData.yn_insp === "Y") {
          if (rowData.qt_fail <= rowData.qt_ac) {
            rowNode.setDataValue("yn_confirm", "Y");
          } else {
            rowNode.setDataValue("yn_confirm", "N");
          }
        }
      } else {
        if (rowData.yn_insp === "Y") {
          if (rowData.qt_pass > 0) {
            rowNode.setDataValue("yn_confirm", "Y");
          } else {
            rowNode.setDataValue("yn_confirm", "N");
          }
        } else {
          if (rowData.qt_sample <= rowData.qt_pass)
            rowNode.setDataValue("yn_confirm", "Y");
          else rowNode.setDataValue("yn_confirm", "N");
        }
      }
    }
    if (colId === "yn_confirm") {
      syncHeaderConfirmByLot(rowData?.no_lot);
    }
  };
  const onCellValueChanged3 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "qt_qc_rcl" && rowData.qt_qc_rcl !== 0) {
      rowNode.setDataValue("yn_confirm", "R", "noEvent");
      rowNode.setDataValue(
        "qt_qc_bad",
        rowData.qt_req - rowData.qt_qc_rcl,
        "noEvent"
      );
    }
  };
  const getCheckedHeaderNodes = () => {
    const grid1 = gridRefs.current["grid1"].current;
    const checkedRows = grid1?.getCheckedRows?.() || [];
    const checkedRowSet = new Set(checkedRows);
    const checkedKeyFields = new Set(
      checkedRows
        .map((row: any) => row?.KeyField)
        .filter((key: any) => key !== undefined && key !== null)
    );
    const checkedNodes: RowNode[] = [];

    grid1?.forEachNode?.((node: RowNode) => {
      if (!node?.data || node.rowPinned) return;
      if (
        node.data.fixCheckbox ||
        checkedRowSet.has(node.data) ||
        (node.data.KeyField !== undefined &&
          node.data.KeyField !== null &&
          checkedKeyFields.has(node.data.KeyField))
      ) {
        checkedNodes.push(node);
      }
    });

    return checkedNodes;
  };

  const applyQcStatus = (headerNodes: RowNode[], stQc: string) => {
    const grid1 = gridRefs.current["grid1"].current;
    const grid3 = gridRefs.current["grid3"].current;
    const noLots = new Set(
      headerNodes
        .map((node) => node.data?.no_lot)
        .filter((noLot) => noLot !== undefined && noLot !== null)
    );

    grid3?.forEachNode?.((node: RowNode) => {
      if (noLots.has(node.data?.no_lot)) {
        grid3.setValueImmediately(node, "st_qc", stQc);
      }
    });

    headerNodes.forEach((node) => {
      grid1.setValueImmediately(node, "st_qc", stQc);
    });
  };

  const onBtnsClick = async (id: string) => {
    try {
      if (gridRefs.current["grid1"].current?.getDisplayedRowCount() === 0)
        return;
      const searchFormData = searchRef.current.getFormdata();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const checkedHeaderNodes = getCheckedHeaderNodes();

      if (id === "btnReport") {
        if (checkedHeaderNodes.length === 0) {
          await showDialog("warning", "체크된 행이 없습니다.");
          return;
        }
        if (btnText.report === "성적서취소") {
          // 성적서 취소 로직
          applyQcStatus(checkedHeaderNodes, "F");
          const newData = {
            ...formData,
            st_qc: "F",
          };
          setFormData(newData);
          setBtnText({
            report: "성적서작성",
            send: "발송",
          });
          await onSave();
        } else {
          // 성적서 작성 로직
          if (
            searchFormData.st_qc === "C" ||
            checkedHeaderNodes.some((node) => node.data?.st_qc === "C")
          ) {
            await showDialog(
              "warning",
              "검사항목이 LOT생성건이 아닙니다.\nLOT생성 건인 경우만 가능합니다."
            );
          } else {
            // 자동발송(QMS0004 = "Y")이면 성적서작성과 동시에 발송(C)까지 처리
            const stQc = autoSend ? "C" : "R";
            applyQcStatus(checkedHeaderNodes, stQc);
            const newData = {
              ...formData,
              st_qc: stQc,
            };
            setFormData(newData);
            setBtnText({
              report: autoSend ? "성적서작성" : "성적서취소",
              send: autoSend ? "발송취소" : "발송",
            });
            await onSave();
          }
        }
      } else if (id === "btnSend") {
        if (checkedHeaderNodes.length === 0) {
          await showDialog("warning", "체크된 행이 없습니다.");
          return;
        }
        if (btnText.send === "발송취소") {
          // 발송 취소 로직
          applyQcStatus(checkedHeaderNodes, "R");
          const newData = {
            ...formData,
            st_qc: "R",
          };
          setFormData(newData);
          setBtnText({
            report: "성적서취소",
            send: "발송",
          });
          await onSave();
        } else {
          // 발송 로직
          if (
            searchFormData.st_qc === "F" ||
            checkedHeaderNodes.some((node) => node.data?.st_qc === "F")
          ) {
            await showDialog(
              "warning",
              "검사항목이 성적서 작성 건이 아닙니다.\n성적서 작성 건인 경우만 가능합니다."
            );
            return;
          } else {
            applyQcStatus(checkedHeaderNodes, "C");
            const newData = {
              ...formData,
              st_qc: "C",
            };
            setFormData(newData);
            setBtnText({
              report: "성적서작성",
              send: "발송취소",
            });
            await onSave();
          }
        }
      } else if (id === "btnDetail") {
        if (searchFormData.st_qc !== "R") {
          await showDialog(
            "warning",
            "검사항목이 성적서 작성 건이 아닙니다.\n성적서 작성 건인 경우만 가능합니다."
          );
          return;
        } else if (focusedNodeH.data.yn_confirm === "Y") {
          await showDialog(
            "warning",
            "적합여부가 부적합인 건만 세목판정이 가능합니다."
          );
          return;
        }
        setFocusedIndex(focusedNodeH.rowIndex);
        const selectedData = {
          cd_item: focusedNodeH.data.cd_item,
          nm_item: focusedNodeH.data.nm_item,
          dc_item_spec: focusedNodeH.data.dc_item_spec,
          dc_item_unit: focusedNodeH.data.dc_item_unit,
          no_lot: focusedNodeH.data.no_lot,
          cd_firm: focusedNodeH.data.cd_firm,
        };
        const component = (
          <SN_QMS_REQ_REG_002_POP_01 selectedDataList={selectedData} />
        );
        const result = await showPopupModal({
          title: "세목판정",
          children: component,
          validation: false,
          width: "69%",
        });
        if (!result || result === "close") return;
        await onSearch();
      } else if (id === "btnReload") {
        if (searchFormData.st_qc !== "F") {
          await showDialog(
            "warning",
            "검사항목이 LOT생성건이 아닙니다.\n LOT생성 건인 경우만 가능합니다."
          );
          return;
        }
        setFocusedIndex(focusedNodeH.rowIndex);
        const rowFocused = gridRefs.current["grid2"].current.focusedRowNode();
        const selectedData = {
          cd_item: focusedNodeH.data.cd_item,
          nm_item: focusedNodeH.data.nm_item,
          dc_item_spec: focusedNodeH.data.dc_item_spec,
          dc_item_unit: focusedNodeH.data.dc_item_unit,
          cd_sip: focusedNodeH.data.cd_sip,
          no_lot: focusedNodeH.data.no_lot,
          cd_firm: focusedNodeH.data.cd_firm,
          qt_lot: focusedNodeH.data.qt_lot,
          no_line: rowFocused.data.no_line,
        };
        if (rowFocused.data.yn_insp === "N") {
          await showDialog(
            "warning",
            "측정치 유무가 '예'인 것만 측정치입력 가능합니다."
          );
          return;
        }
        const rowDataList = {
          cd_clause: rowFocused.data.cd_clause,
          dc_ucl: String(rowFocused.data.dc_ucl ?? "0"),
          dc_lcl: String(rowFocused.data.dc_lcl ?? "0"),
          qt_ac: String(rowFocused.data.qt_ac ?? "0"),
          qt_re: String(rowFocused.data.qt_re ?? "0"),
          yn_confirm: rowFocused.data.yn_confirm,
          nm_confirm: rowFocused.data.nm_confirm,
          qt_sample: rowFocused.data.qt_sample,
          no_line: rowFocused.data.no_line,
        };
        const component = (
          <SN_QMS_REQ_REG_002_POP_02
            selectedDataList={selectedData}
            rowDataList={rowDataList}
          />
        );
        const result = await showPopupModal({
          title: "측정치입력",
          children: component,
          validation: false,
          width: "69%",
        });
        if (!result || result === "close") return;
        if (focusedNodeH) {
          focusKeyRef.current = {
            no_lot: focusedNodeH.data.no_lot,
          };
        }
        await onSearch();
      } else if (id === "btnResult") {
        let max_qt_fail = 0,
          min_qt_pass = Number.MAX_SAFE_INTEGER,
          qt_sample_val = 0,
          yn_insp_flag = false;
        gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
          const fail_val = Number(node.data?.qt_fail || 0);
          const pass_val = Number(node.data?.qt_pass || 0);
          qt_sample_val = Number(node.data?.qt_sample || 0);
          if (max_qt_fail < fail_val) {
            max_qt_fail = fail_val;
            yn_insp_flag = true;
          }
          if (min_qt_pass > pass_val) {
            yn_insp_flag = true;
            min_qt_pass = pass_val;
          }
        });
        const footerData = gridRefs.current["grid3"].current.getFooterData();
        const sum_qt_req = footerData.qt_req;

        const nodes: any[] = [];
        gridRefs.current["grid3"].current.forEachFilteredNode((node: any) => {
          node.setDataValue("qt_qc", node.data.qt_req, "noEvent");
          node.setDataValue("qt_sample", qt_sample_val, "noEvent");
          node.setDataValue(
            "yn_confirm",
            focusedNodeH.data.yn_confirm,
            "noEvent"
          );
          nodes.push(node);
        });

        let accFail = 0,
          accPass = 0;
        nodes.forEach((node, idx) => {
          const qt_req = Number(node.data?.qt_req || 0);

          let qt_fail_calc = 0,
            qt_pass_calc = 0;

          if (idx === nodes.length - 1) {
            qt_fail_calc = max_qt_fail - accFail;
            qt_pass_calc = min_qt_pass - accPass;
            if (nodes.length === 1) qt_pass_calc = min_qt_pass;
          } else {
            qt_fail_calc = Math.floor((max_qt_fail * qt_req) / sum_qt_req);
            accFail += qt_fail_calc;
            qt_pass_calc = Math.floor((min_qt_pass * qt_req) / sum_qt_req);
            accPass += qt_pass_calc;
          }

          node.setDataValue("qt_qc_bad", qt_fail_calc, "noEvent");
          node.setDataValue("qt_qc_good", qt_pass_calc, "noEvent");
        });
      } else if (id === "btnCalculate") {
        // cd_aql은 코드값으로 nm_aql전송으로
        const payload = {
          id: "ksa",
          params: {
            cd_firm: userInfo.cd_firm,
            fg_level: focusedNodeH.data.fg_level,
            fg_grade: focusedNodeH.data.fg_grade,
            cd_aql: focusedNodeH.data.nm_aql,
            qt_lot: focusedNodeH.data.qt_lot,
          },
        };
        const data = await fnGetTableById(payload);
        const ksa = Array.isArray(data) && data.length > 0 ? data[0] : [];
        gridRefs.current["grid2"].current.forEachFilteredNode(
          (node: RowNode) => {
            if (node.data.yn_sample === "Y") {
              node.setDataValue("qt_sample", ksa.qt_sample);
              node.setDataValue("qt_ac", ksa.qt_ac);
              node.setDataValue("qt_re", ksa.qt_re);
            } else {
              node.setDataValue(
                "qt_sample",
                focusedNodeH.data.qt_lot,
                "noEvent"
              );
            }
          }
        );
      } else if (id === "btnInspectionLevel") {
        if (checkedHeaderNodes.length === 0) {
          await showDialog("warning", "체크된 행이 없습니다.");
          return;
        }

        const cdItems = Array.from(
          new Set(
            checkedHeaderNodes
              .map((node) => node.data?.cd_item)
              .filter(
                (cdItem) =>
                  cdItem !== undefined && cdItem !== null && cdItem !== ""
              )
          )
        );

        if (cdItems.length === 0) {
          await showDialog("warning", "품목코드가 없습니다.");
          return;
        }

        const itemInfo = {
          id: "item",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_items: cdItems,
          },
        };
        const data = await fnGetTableById(itemInfo);
        const itemMap = new Map();

        if (Array.isArray(data)) {
          data.forEach((item: any) => {
            itemMap.set(item.cd_item, item);
          });
        }

        if (itemMap.size === 0) {
          await showDialog("warning", "조회된 품목정보가 없습니다.");
          return;
        }

        const grid1 = gridRefs.current["grid1"].current;
        checkedHeaderNodes.forEach((node) => {
          const item = itemMap.get(node.data?.cd_item);
          if (!item) return;

          grid1.setValueImmediately(node, "fg_grade", item.fg_grade ?? "");
          grid1.setValueImmediately(node, "nm_aql", item.nm_aql ?? "");
          grid1.setValueImmediately(node, "cd_aql", item.dc_aql ?? "");
        });
      }
    } catch (error: any) {
      await showDialog("error", error.message);
    }
  };
  const onGridBtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    } else if (id === "deleteRow") {
      onDeleteRow();
    }
  };
  const onAddRow = async () => {
    try {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        await showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }
      const maxNoLine =
        gridRefs.current["grid4"].current.getMaxValue("no_line");

      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_lot: focusedNodeH.data.no_lot,
        no_line: maxNoLine + 1,
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
      };
      gridRefs.current["grid4"].current.addRow(newRow);
    } catch (error: any) {}
  };
  const onDeleteRow = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) {
      return;
    }
    gridRefs.current["grid4"].current?.deleteSelectedRows();
  };
  const TabChangedEvent = async (index: any) => {
    selectedTabPage.current = index;
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() === 0) return;
    const rowNode = gridRefs.current["grid1"].current.focusedRowNode();
    if (selectedTabPage.current === "1") {
      gridRefs.current["grid2"].current?.applyFilters({
        no_lot: rowNode.data.no_lot,
      });
    } else if (selectedTabPage.current === "2") {
      gridRefs.current["grid3"].current?.applyFilters({
        no_lot: rowNode.data.no_lot,
      });
    } else {
      gridRefs.current["grid4"].current?.applyFilters({
        no_lot: rowNode.data.no_lot,
      });
    }
  };
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_lot = selectedRow.no_lot;
      gridRefs.current["grid2"].current.applyFilters({
        no_lot: no_lot,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
      gridRefs.current["grid3"].current.applyFilters({
        no_lot: no_lot,
      });
      gridRefs.current["grid3"].current.selectAndFocusRow(0);
      gridRefs.current["grid4"].current.applyFilters({
        no_lot: no_lot,
      });
      gridRefs.current["grid4"].current.selectAndFocusRow(0);
      setSelectedDocu(no_lot);
    } else {
      return;
    }
  };
  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_lot === focusKey.no_lot) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChanged2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onCellValueChanged: onCellValueChanged3,
        },
      },
      grid4: {
        columns: columns.grid4,
        dataSource: dataSources.grid4,
        events: {
          onCellValueChanged: onCellValueChanged2,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          onValueChanged={onValueChaged}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              title: "의뢰정보",
              ischeckboxSelection: true,
            }}
            events={grids.grid1.events}
            header={[
              <SnTabHeader
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"검사수준적용"}
                      onClick={() => {
                        onBtnsClick("btnInspectionLevel");
                      }}
                    />
                    <SnButton
                      text={"재계산"}
                      onClick={() => {
                        onBtnsClick("btnCalculate");
                      }}
                    />
                    <SnButton
                      text={btnText.report}
                      onClick={() => {
                        onBtnsClick("btnReport");
                      }}
                    />
                    {(!autoSend || btnText.send === "발송취소") && (
                      <SnButton
                        text={btnText.send}
                        onClick={() => {
                          onBtnsClick("btnSend");
                        }}
                      />
                    )}
                  </div>
                }
              />,
            ]}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["검사항목", "검사의뢰", "불량내역"]}
            width={"100%"}
            onTabChanged={TabChangedEvent}
            header={[
              <SnTabHeader
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"세목판정"}
                      onClick={() => {
                        onBtnsClick("btnDetail");
                      }}
                    />
                    <SnButton
                      text={"측정치입력"}
                      onClick={() => {
                        onBtnsClick("btnReload");
                      }}
                    />
                  </div>
                }
              />,
              <SnTabHeader
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"검사결과적용"}
                      onClick={() => {
                        onBtnsClick("btnResult");
                      }}
                    />
                    <SnButton
                      text={"세목판정"}
                      onClick={() => {
                        onBtnsClick("btnDetail");
                      }}
                    />
                    <SnButton
                      text={"측정치입력"}
                      onClick={() => {
                        onBtnsClick("btnReload");
                      }}
                    />
                  </div>
                }
              />,
              <SnTabHeader
                onBtnAddClick={onGridBtnsClick}
                onBtnDeleteClick={onGridBtnsClick}
              />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                events={grids.grid2.events}
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,

              <SnGrid
                ref={gridRefs.current["grid3"]} // Grid Name
                columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                rowData={grids.grid3.dataSource} // Datasource
                events={grids.grid3.events}
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,
              <SnGrid
                ref={gridRefs.current["grid4"]} // Grid Name
                columnConfig={grids.grid4.columns} // 컬럼 설정 전달
                rowData={grids.grid4.dataSource} // Datasource
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
});

export default SN_QMS_REQ_REG_002;
